import { Link } from 'react-router-dom';
import { imageUrl } from '../api/client.js';
import { BookIcon, EyeIcon } from './icons.jsx';

const STYLE_LABEL = {
  watercolor: 'Acuarela',
  cartoon: 'Cartoon',
  pixar3d: '3D',
  storybook: 'Clasico',
  papercut: 'Papercut',
  pixel: 'Pixel',
};

const LANG_LABEL = {
  'es-neutro': 'ES',
  'es-ar': 'ES-AR',
  'es-an': 'ES-AN',
  'es-mx': 'ES-MX',
  en: 'EN',
};

export default function StoryCard({ story }) {
  return (
    <Link
      to={`/story/${story.slug}`}
      className="group flex flex-col overflow-hidden rounded-2xl border border-brand-100 bg-white shadow-sm transition hover:-translate-y-0.5 hover:shadow-lg"
    >
      <div className="relative aspect-square w-full overflow-hidden bg-brand-50">
        {story.thumbnailImageId ? (
          <img
            src={imageUrl(story.thumbnailImageId)}
            alt={story.title}
            loading="lazy"
            className="h-full w-full object-cover transition duration-500 group-hover:scale-[1.04]"
          />
        ) : (
          <div className="flex h-full items-center justify-center text-brand-300">
            <BookIcon size="64" />
          </div>
        )}
        <div className="absolute right-2 top-2 flex gap-1">
          {STYLE_LABEL[story.style] && (
            <span className="rounded-full bg-white/90 px-2 py-0.5 text-[10px] font-semibold text-brand-700 shadow">
              {STYLE_LABEL[story.style]}
            </span>
          )}
          {LANG_LABEL[story.language] && (
            <span className="rounded-full bg-brand-700/90 px-2 py-0.5 text-[10px] font-semibold text-white shadow">
              {LANG_LABEL[story.language]}
            </span>
          )}
        </div>
      </div>
      <div className="flex-1 p-4">
        <h3 className="line-clamp-2 font-semibold text-brand-700 group-hover:text-brand-600">
          {story.title}
        </h3>
        <p className="mt-1 flex items-center gap-2 text-xs text-gray-500">
          <span>{new Date(story.created_at).toLocaleDateString()}</span>
          {story.view_count > 0 && (
            <span className="inline-flex items-center gap-1">
              · <EyeIcon size="0.95em" /> {story.view_count}
            </span>
          )}
        </p>
      </div>
    </Link>
  );
}
